// extracted by mini-css-extract-plugin
export default {"container":"PopupMenuButton_container__cXD0R","arrow":"PopupMenuButton_arrow__D2vEe"};